import type { ReactNode } from 'react';

export type TomDoAviso = 'ok' | 'erro' | 'neutro';

export interface Mensagem {
  tom: TomDoAviso;
  texto: ReactNode;
}

export function Aviso({ mensagem }: { mensagem: Mensagem | null }) {
  if (!mensagem) return null;
  return <div className={`aviso ${mensagem.tom}`}>{mensagem.texto}</div>;
}

/** Extrai a mensagem legível de um erro vindo da API ou de uma exceção qualquer. */
export function mensagemDoErro(erro: unknown): string {
  if (erro instanceof Error) return erro.message;
  return 'Erro inesperado. Tente novamente.';
}
